import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {
    changeBottomNavigation,
    changeTitle,
    setRouteListOrigin,
    setStateGoBackUrl,
    showMenuNavBar
} from "../../actions";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import RouteListComponent from "../../components/Route/RouteListComponent/RouteListComponent";
import Constants from "../../config/constants";
import {useMatomo} from "@datapunt/matomo-tracker-react";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls} from "../../config/urls";
import {useParams} from "react-router-dom";

const screenName = Constants.SCREEN_NAME.SEARCH;
const SearchScreen = ({i18n, t, query, onTitleChange, onBottomNavigationChange, onShowMenuNavBar, setRouteListOrigin}) => {
    const {term} = useParams();
    const { trackPageView } = useMatomo();

    const canonical = getUrl(PWAUrls.SEARCH, {lng: i18n.language});
    useSEO({title: t("seo.title.search"), description: t("seo.description.search")}, canonical);
    useEffect(() => {
        trackPageView({
            documentTitle: t("SearchScreen.title"), // optional
            href: window.location.pathname,
        });
        setRouteListOrigin( window.location.pathname);
    }, []);

    useEffect(() => {
        onTitleChange(t("SearchScreen.title"));
        onBottomNavigationChange(true);
        onShowMenuNavBar(true);
    }, [t, onTitleChange, onBottomNavigationChange, onShowMenuNavBar]);

    if (typeof term !== "undefined") {
        query.q = term;
    }

    return (<RouteListComponent
            screenName={screenName}
            query={query}
            facetDistribution={[
                {name: 'types', display: {type: 'multiple', grid: 12}},
                {name: 'family', display: {type: 'boolean'}},
                {name: 'equipmentTypes', display: {type: 'multiple', grid: 12}},
                {name: 'regionIds', display: {type: 'tree'}},
                {name: 'orientations', display: {type: 'multiple', grid: 6}},
                {name: 'difficulties', display: {type: 'multiple', grid: 6}},
                // {name: 'guidebookIds', display: {type: 'multiple', grid: 12, sort: 'alphanum'}},
            ]}
        />);
};

const mapStateToProps = (state) => {
    let defaultQuery = {
        q: '',
        order: Constants.RouteListComponent.queryOrder.region,
        facets: [],
        screenChoices: [],
        myroute: false,
        lastVersion: true,
        choices: [{name: 'regionIds', selected: [],}],
        offset: 0,
        limit: 20,
        language: null,
        version: 2,
    };

    let props = {};
    if (typeof state.search.queries[screenName] === "undefined"
        || state.search.queries[screenName]?.version !== defaultQuery.version) {
        props = {...props, query: defaultQuery}
    } else {
        props = {...props, query: state.search.queries[screenName]}
    }

    return props;
};

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        onBottomNavigationChange: (icons) => {
            dispatch(changeBottomNavigation(icons))
        },
        onShowMenuNavBar: (showMenuNavBarBool) => {
            dispatch(showMenuNavBar(showMenuNavBarBool))
        },
        setGoBackUrl: (url, params) => {
            dispatch(setStateGoBackUrl(url, params))
        },
        setRouteListOrigin: (url) => {
            dispatch(setRouteListOrigin(url))
        },
    }
};

export default compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(SearchScreen)